/**
 * ProgressIndicator Component
 *
 * Displays visual progress through the 5-step assessment wizard
 */

export default function ProgressIndicator({ currentStep, onStepClick }) {
  const steps = [
    { number: 1, label: 'Customer' },
    { number: 2, label: 'Location' },
    { number: 3, label: 'System' },
    { number: 4, label: 'Technical' },
    { number: 5, label: 'Comfort' }
  ];

  return (
    <div style={{
      marginBottom: '30px',
      padding: '20px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      {/* Progress bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '15px',
        position: 'relative'
      }}>
        {/* Background line */}
        <div style={{
          position: 'absolute',
          top: '15px',
          left: '0',
          right: '0',
          height: '4px',
          background: '#e0e6ed',
          zIndex: 0
        }} />

        {/* Progress line */}
        <div style={{
          position: 'absolute',
          top: '15px',
          left: '0',
          width: `${((currentStep - 1) / 4) * 100}%`,
          height: '4px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          transition: 'width 0.3s ease',
          zIndex: 1
        }} />

        {/* Step circles */}
        {steps.map((step) => {
          const isActive = step.number === currentStep;
          const isCompleted = step.number < currentStep;
          const isClickable = step.number <= currentStep;

          return (
            <button
              key={step.number}
              onClick={() => isClickable && onStepClick && onStepClick(step.number)}
              disabled={!isClickable}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                border: 'none',
                background: isCompleted || isActive
                  ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                  : '#e0e6ed',
                color: 'white',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: isClickable ? 'pointer' : 'default',
                zIndex: 2,
                position: 'relative',
                transition: 'all 0.3s ease',
                transform: isActive ? 'scale(1.15)' : 'scale(1)',
                boxShadow: isActive ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none'
              }}
            >
              {isCompleted ? '✓' : step.number}
            </button>
          );
        })}
      </div>

      {/* Step labels */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        {steps.map((step) => {
          const isActive = step.number === currentStep;

          return (
            <div
              key={step.number}
              style={{
                flex: 1,
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: isActive ? '600' : '400',
                color: isActive ? '#667eea' : '#64748b',
                transition: 'all 0.3s ease'
              }}
            >
              {step.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
